import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'cpf-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class LoginPageComponent {

}
